exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".component-body {\r\n  /*margin-left: 20px;*/\r\n  /*margin-right: 20px;*/\r\n  padding: 20px;\r\n  background-color: white;\r\n}\r\n\r\n.block {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/translate/translate-standard/translate-standard.component.css
// module id = ../../../../../src/app/content-page/translate/translate-standard/translate-standard.component.css
// module chunks = main